import { render } from "./subindex.vue?vue&type=template&id=5f04da15"
import script from "./subindex.vue?vue&type=script&lang=js"
export * from "./subindex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__